class KabilaCustomDiscountTrigger {
    static applicableDiscountCode = ""

    static async init() {
        const cardUI = await this.buildCardUI()

        const parent = document.querySelector("#Cart-Content-Sidebar .previewCartInfo")
        if (!parent) {
            return;
        }
        document.getElementById("kbCartDiscountCard")?.remove();
        parent.insertAdjacentHTML("afterbegin", cardUI);
        this.addEventListeners();
    }

    static async buildCardUI() {
        const utmSource = KabilaSessionStorage.getUTMSource();
        if (utmSource === 'app') {
            const cardForApp = await this.buildAppCardUI();
            return cardForApp;
        } else {
            const cardForWeb = this.buildWebCardUI();
            return cardForWeb;
        }
    }

    static buildWebCardUI() {
        const cardForWeb = `
            <div id="kbDiscountImageCarousel" class="kabila-image-carousel-container">
                <div class="kabila-image-carousel-heading">How to save aditional ₹1000 <span>In App</span></div>
                <div class="kabila-image-carousel scrollbar-hide">
                <a href="https://kabilashop.page.link/j5nk" target="_blank" class="kabila-image-carousel-item">
                    <img src="https://media.shuru.co.in/input/1744879665518_612196.webp" alt="Image1">
                </a>
                <a href="https://kabilashop.page.link/j5nk" target="_blank" class="kabila-image-carousel-item">
                    <img src="https://media.shuru.co.in/input/1744879665521_32417.webp" alt="Image2">
                </a>
                </div>
            </div>
        `
        return cardForWeb;
    }

    static addEventListeners() {
        const applyBtn = document.querySelector("#kbSideCartApplyDiscountBtn");
        if (applyBtn) {
            applyBtn.addEventListener("click", () => {
                applyBtn.disabled = true;
                KabilaCartDiscountContainer.onClickApply(this.applicableDiscountCode);
            });
        }
        const removeBtn = document.querySelector("#kbSideCartRemoveDiscountBtn");
        if (removeBtn) {
            removeBtn.addEventListener("click", () => {
                removeBtn.disabled = true;
                KabilaCartDiscountContainer.onClickRemove(this.applicableDiscountCode);
            });
        }
    }

    static buildDiscountActionCTA(isDiscountApplied, discountCode) {
        this.applicableDiscountCode = discountCode;
        const removeBtn = `
            <button id="kbSideCartRemoveDiscountBtn" class="flex-center kabila-cart-discounts__remove-btn">
                <span>Remove</span>
                <svg
                    class="kabila-cart-discounts__container__icon--sm"
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path>
                </svg>
            </button>
        `
        const applyBtn = `
            <button id="kbSideCartApplyDiscountBtn" class="flex-center kabila-cart-discounts__add-btn">
                <span>Apply</span>
            </button>
        `

        if (isDiscountApplied) {
            return removeBtn;
        } else {
            return applyBtn;
        }
    }

    static getApplicableDiscount(discountCodes) {
        const localList = KabilaLocalStorage.getAppliedCoupons() // string[]
        const newList = []
        discountCodes.forEach((item) => {
            const code = item.node.discount.codes.edges[0].node.code;
            if (!localList.includes(code)) {
                newList.push(item);
            }
        });
        return newList;
    }

    static async buildAppCardUI() {
        const cart = await ShopifyAjaxAPI.getCart();
        const discount = cart.cart_level_discount_applications.find((item) => item.title.includes('_APP_EXCLUSIVE'));
        const isDiscountApplied = discount ? true : false;
        let title = ""
        let discountCode = ""
        let value = 0;
        let valueLabel = ""
        console.log({ discount })
        if (discount) {
            title = discount.title
            discountCode = discount.title;
            value = discount.total_allocated_amount / 100;
            valueLabel = `Offer Applied, ₹${value} extra Saved`
        } else {
            const response = await KabilaGlobalApi.getDiscountCoupons();
            console.log({ response });
            const discountCodes = response.discountNodes.edges;
            const applicableDiscountList = this.getApplicableDiscount(discountCodes);
            const applicableDiscount = applicableDiscountList?.[0];

            if (!applicableDiscount) {
                return "";
            }

            title = applicableDiscount?.node?.discount?.codes?.edges?.[0]?.node?.code
            value = Number(applicableDiscount?.node?.discount?.customerGets?.value?.amount?.amount);
            valueLabel = `Save ₹${value} by applying this coupon`
            discountCode = title;
        }

        title = title.replace('_APP_EXCLUSIVE', '');

        const cardForApp = `
            <div class="kabila-cart-discounts__container" id="kbCartDiscountCard">
                <div class="flex items-center justify-between">
                    <div class="flex-center">
                    <svg
                        class="kabila-cart-discounts__container__icon icon-discount"
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M13.9461 2.09411C12.8248 1.13855 11.1756 1.13856 10.0544 2.0941L8.70636 3.24286C8.54619 3.37935 8.34705 3.46183 8.13728 3.47857L6.3718 3.61946C4.90327 3.73665 3.73714 4.90278 3.61995 6.3713L3.47907 8.13678C3.46234 8.34654 3.37983 8.54573 3.24334 8.70589L2.09458 10.0539C1.13904 11.1752 1.13905 12.8243 2.0946 13.9455L3.24336 15.2936C3.37983 15.4538 3.46232 15.6529 3.47906 15.8627L3.61997 17.6281C3.73716 19.0966 4.9033 20.2627 6.37184 20.3799L8.13729 20.5209C8.34705 20.5376 8.54615 20.6201 8.70631 20.7566L10.0543 21.9053C11.1756 22.8608 12.8248 22.8609 13.9461 21.9053L15.2941 20.7566C15.4542 20.6201 15.6533 20.5376 15.8631 20.5208L17.6286 20.3799C19.0971 20.2628 20.2632 19.0967 20.3805 17.6281L20.5213 15.8627C20.538 15.6529 20.6206 15.4537 20.757 15.2935L21.9058 13.9456C22.8614 12.8243 22.8614 11.1751 21.9058 10.0539L20.757 8.70585C20.6205 8.54568 20.5381 8.34654 20.5214 8.13679L20.3805 6.37131C20.2633 4.9028 19.0971 3.73663 17.6286 3.61945L15.8631 3.47856C15.6533 3.46182 15.4542 3.37935 15.2941 3.24286L13.9461 2.09411ZM14.8284 7.75718L16.2426 9.1714L9.17151 16.2425L7.7573 14.8282L14.8284 7.75718ZM10.2322 10.232C9.64638 10.8178 8.69664 10.8178 8.11085 10.232C7.52506 9.6463 7.52506 8.69652 8.11085 8.11073C8.69664 7.52494 9.64638 7.52494 10.2322 8.11073C10.818 8.69652 10.818 9.6463 10.2322 10.232ZM13.7677 15.8889C13.1819 15.3031 13.1819 14.3534 13.7677 13.7676C14.3535 13.1818 15.3032 13.1818 15.889 13.7676C16.4748 14.3534 16.4748 15.3031 15.889 15.8889C15.3032 16.4747 14.3535 16.4747 13.7677 15.8889Z"></path>
                    </svg>
                    <span class="kabila-cart-discounts__discount-code">${title}</span>
                    </div>
                    ${this.buildDiscountActionCTA(isDiscountApplied, discountCode)}
                </div>
                <div class="flex items-center justify-between mt-2">
                    <div class="kabila-cart-discounts__discount-description">${valueLabel}</div>
                    <button onclick="KabilaCartDiscountContainer.show();" class="flex-center kabila-cart-discounts__view-coupons-btn">
                    <span>View Coupons</span>
                    <svg
                        class="kabila-cart-discounts__container__icon--sm"
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path fill="none" stroke-linecap="square" stroke-miterlimit="10" stroke-width="48" d="m184 112 144 144-144 144"></path>
                    </svg>
                    </button>
                </div>
            </div>
        `
        return cardForApp;
    }
}

class KabilaGlobalInit {
    static async init() {
        this.readQueryParams();
        await this.initUser()
    }

    static readQueryParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const utm_origin = urlParams.get('utm_origin');
        const utm_source = urlParams.get('utm_source');
        const utm_source_src = urlParams.get('src');
        if (utm_origin) {
            KabilaSessionStorage.setUTMOrigin(utm_origin);
        }
        if (utm_source || utm_source_src) {
            KabilaSessionStorage.setUTMSource(utm_source || utm_source_src);
        }
    }

    static async initUser() {
        let uid = KabilaLocalStorage.getUUID();
        if (!uid) {
            const registerUserResponse = await KabilaGlobalApi.registerUser();

            console.log(registerUserResponse);

            if (registerUserResponse.status !== 201) {
                console.error("Unable to register user.");
                return;
            }

            const uidFromApi = registerUserResponse?.data?.[0]?.uid
            if (!uidFromApi) {
                console.error("Uid not received from api.");
                return;
            }

            KabilaLocalStorage.setUUID(uidFromApi);
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    KabilaGlobalInit.init();
});
